import React, { useRef, useMemo, useCallback } from "react";
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import TextBox from 'devextreme-react/text-box';
import handlePostRequestAssist from '../../Utils/handlePOST/handlePostRequestAssist'
import useFetch from '../../Hooks/useFetch';
import { useNavigate } from 'react-router-dom';
import { isMobile } from '../../Utils/media-query';


export default function RequestAssistance({ orderId, setNotifications, onClose }) {
	const navigate = useNavigate()
		, fetch = useFetch(navigate);

	const issue = useRef('');
	const onValueChanged = (e) => {
		issue.current = e.value;
	}

	const submitAssistance = useCallback(async () => {
		const { response, isDataGood } = await handlePostRequestAssist(issue.current, orderId, fetch);
		setNotifications(response);
		if (isDataGood) {
			onClose();
		}
	}, [orderId, fetch, onClose, setNotifications]);

	const submitOptions = useMemo(() => { 
		return {
			stylingMode: 'contained',
			text: "Send",
			onClick: () => { submitAssistance() }
		}
	}, [submitAssistance])

	const cancelOptions = useMemo(() => {
		return {
			stylingMode: "outlined",
			text: 'cancel',
			onClick: () => onClose()
		}
	}, [onClose])

	return (
		<Popup
			visible={true}
			onHiding={() => onClose()}
			hideOnOutsideClick={true}
			title="Request Assistance"
			width={isMobile ? '100%' : '50%'}
			height="auto"
			resizeEnabled={true}
		>
			<TextBox
				spellcheck={true}
				placeholder="Type comment..."
				onValueChanged={onValueChanged}
				valueChangeEvent="input" />
			<ToolbarItem
				widget="dxButton"
				toolbar="bottom"
				location="after"
				options={cancelOptions}
			/>
			<ToolbarItem
				widget="dxButton"
				toolbar="bottom"
				location="after"
				options={submitOptions}
			/>
		</Popup>
	);
}
